import { render, staticRenderFns } from "./LangBox.vue?vue&type=template&id=2c41c49c&scoped=true&"
import script from "./LangBox.vue?vue&type=script&lang=js&"
export * from "./LangBox.vue?vue&type=script&lang=js&"
import style0 from "./LangBox.vue?vue&type=style&index=0&id=2c41c49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c41c49c",
  null
  
)

export default component.exports